var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"pay-button",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.pay}},[_vm._v("PAY WITH SWITCHERE")])])}
var staticRenderFns = []

export { render, staticRenderFns }